// extracted by mini-css-extract-plugin
export var borderRadius = "_go-4";
export var large = "_go-3";
export var logoContainer = "_go-0";
export var nameLogo = "_go-2";
export var small = "_go-1";